import * as React from 'react';
const CheckboxTree = require('react-checkbox-tree');
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IRefinementGroup } from 'models/filtering/refinement';
import { ICategoryDomainValue } from 'models/common';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

let CheckboxTreeLocal = CheckboxTree as any;
if (CheckboxTreeLocal.default) {
	CheckboxTreeLocal = CheckboxTreeLocal.default;
}

interface IProps {
	refinementGroups: IRefinementGroup[];
	categories?: ICategoryDomainValue[];
	selectedCategoryId?: number;
	setSelectedCategory?: (categoryId: number) => void;
	onRefinementClick?: (groupId: number, refinementId: number) => void;
	onPriceValuesChange?: (values: number[]) => void;
	onFinalPriceValuesChange?: (values: number[]) => void;
	t?: (key: string) => string;
	priceStep?: number;
	pricesRefinementGroup?: IRefinementGroup;
}

interface IFilterCategory {
	value: number;
	label: string;
	parentId?: number;
	children: IFilterCategory[];
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ProductFilters extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.state = {};

		this.handleOnRefinementClick = this.handleOnRefinementClick.bind(this);
		this.onCheck = this.onCheck.bind(this);
	}

	private handleOnRefinementClick(groupId: number, refinementId: number) {
		if (this.props.onRefinementClick) {
			this.props.onRefinementClick(groupId, refinementId);
		}
	}

	private getSelectedCategoryRootId(selectedCategoryId: number) {
		const selectedCategoryParentId = this.props.categories.filter(
			(x) => x.key === Number(this.props.selectedCategoryId),
		)[0].parentKey;
		if (selectedCategoryParentId !== null) {
			const selectedCategoryRootId =
				this.props.categories.filter((x) => x.key === selectedCategoryParentId)[0].parentKey !== null
					? this.props.categories.filter(
							(x) => x.key === this.props.categories.filter((x) => x.key === selectedCategoryParentId)[0].parentKey,
					  )[0].parentKey !== null
						? this.props.categories.filter(
								(x) => x.key === this.props.categories.filter((x) => x.key === selectedCategoryParentId)[0].parentKey,
						  )[0].parentKey
						: this.props.categories.filter((x) => x.key === selectedCategoryParentId)[0].parentKey
					: selectedCategoryParentId;
			return selectedCategoryRootId;
		} else {
			return selectedCategoryId; //already at root
		}
	}

	private onCheck(checked: string[]) {
		if (checked.length === 0) {
			// set root of last selected category
			const selectedCategoryRootId = this.getSelectedCategoryRootId(this.props.selectedCategoryId);
			this.props.setSelectedCategory(selectedCategoryRootId);
			return;
		}
		// only 1 category can be selected, splice from checked array if contains currently selectedCategoryId
		if (this.props.selectedCategoryId && checked.indexOf(this.props.selectedCategoryId.toString()) !== -1) {
			checked.splice(checked.indexOf(this.props.selectedCategoryId.toString()), 1);
		}
		this.props.setSelectedCategory(Number(checked[0]));
	}

	private renderCategory(category: IFilterCategory, expanded: number[], child: boolean) {
		let children: JSX.Element | undefined;
		if (category.children.length && expanded.indexOf(category.value) !== -1) {
			children = (
				<div className="accordion">{category.children.map((c) => this.renderCategory(c, expanded, true))}</div>
			);
		}
		return (
			<div className="accordion__item" key={category.value}>
				<div className={`accordion__heading ${child ? 'isChild' : ''}`}>
					<div
						className={'accordion__button ' + (this.props.selectedCategoryId === category.value ? 'active' : '')}
						aria-expanded={this.props.selectedCategoryId === category.value ? 'true' : 'false'}
						onClick={() => this.props.setSelectedCategory(category.value)}
					>
						{category.label}
					</div>
				</div>
				{children}
			</div>
		);
	}

	public render() {
		const { t } = this.props;

		return (
			<div className="productFilters">
				<p className="p14">
					{(t('BSPortal_Common_All') + ' ' + t('Portal_LeftSideMenu_ManageShop_Products')).toUpperCase()}
				</p>
				<div className="filtersGroups"></div>
			</div>
		);
	}
}

export { ProductFilters };
